class FBStickyAtc {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.trigger = this.getTrigger();
    this.mainButton = this.getMainButton();
    this.priceRoot = this.getPriceRoot();
    this.submitButton = container.querySelector('[data-sticky-atc-submit]');
    this.label = container.querySelector('[data-sticky-atc-label]');
    this.price = container.querySelector('[data-sticky-atc-price]');
    this.customButtonLabel = container.dataset.stickyAtcButtonLabel?.trim();

    if (!this.sectionId || !this.trigger || !this.mainButton || !this.submitButton) {
      return;
    }

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        const shouldShow = !entry.isIntersecting;
        this.container.hidden = !shouldShow;
        this.container.classList.toggle('is-visible', shouldShow);
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -24px 0px',
      }
    );

    this.intersectionObserver.observe(this.trigger);

    this.mainObserver = new MutationObserver(() => {
      this.sync();
    });

    this.mainObserver.observe(this.mainButton, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
    });

    if (this.priceRoot) {
      this.priceObserver = new MutationObserver(() => {
        this.sync();
      });

      this.priceObserver.observe(this.priceRoot, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    this.sync();
  }

  getSection() {
    return document.getElementById(`MainProduct-${this.sectionId}`);
  }

  getMainButton() {
    return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
  }

  getPriceRoot() {
    return document.getElementById(`price-${this.sectionId}`);
  }

  getTrigger() {
    const section = this.getSection();
    return section ? section.querySelector('[data-sticky-atc-sentinel]') : null;
  }

  extractButtonLabel(button) {
    const label = button?.querySelector('span');
    return label ? label.textContent.trim() : '';
  }

  extractPriceText(priceRoot) {
    if (!priceRoot) {
      return '';
    }

    const priceNode = priceRoot.querySelector('.price');

    if (!priceNode) {
      return '';
    }

    if (priceNode.classList.contains('price--on-sale')) {
      const saleNode = priceNode.querySelector('.price__sale .price-item--last');
      return saleNode ? saleNode.textContent.trim() : '';
    }

    const regularNode = priceNode.querySelector('.price__regular .price-item--regular');
    return regularNode ? regularNode.textContent.trim() : '';
  }

  sync() {
    const labelText = this.customButtonLabel || this.extractButtonLabel(this.mainButton) || 'Dodaj do koszyka';
    const priceText = this.extractPriceText(this.priceRoot);
    const isDisabled =
      this.mainButton.hasAttribute('disabled') ||
      this.mainButton.getAttribute('aria-disabled') === 'true';

    this.label.textContent = labelText;
    this.price.textContent = priceText;
    this.submitButton.disabled = isDisabled;
  }
}

const initFBStickyAtc = () => {
  document.querySelectorAll('[data-sticky-atc-container]').forEach((container) => {
    if (container.dataset.stickyAtcReady === 'true') {
      return;
    }

    container.dataset.stickyAtcReady = 'true';
    new FBStickyAtc(container);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFBStickyAtc);
} else {
  initFBStickyAtc();
}

document.addEventListener('shopify:section:load', initFBStickyAtc);
